module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "客户名称"
    },
    model: {
      value: (_vm.filters.guestComName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "guestComName", $$v)
      },
      expression: "filters.guestComName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.guestCompanyList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (!_vm.bquery) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAddbzhFile
    }
  }, [_vm._v("新增协议客户")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.comguestlist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "guestComName",
      "label": "客户名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "guestDate",
      "label": "协议签订时间",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "guestGoods",
      "label": "物品名称",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), (!_vm.bquery) ? _c('el-table-column', {
    attrs: {
      "prop": "guestCode",
      "label": "信用代码",
      "align": "center",
      "min-width": "150"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.bquery) ? _c('el-table-column', {
    attrs: {
      "prop": "guestName",
      "label": "法人或寄件人姓名",
      "align": "center",
      "min-width": "120"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.bquery) ? _c('el-table-column', {
    attrs: {
      "prop": "guestWid",
      "label": "法人或寄件人身份证号",
      "align": "center",
      "min-width": "150"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.bquery) ? _c('el-table-column', {
    attrs: {
      "prop": "guestPhone",
      "label": "法人或寄件人电话",
      "align": "center",
      "min-width": "120"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.bquery) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "400"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看协议")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleWidNoShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看证件")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.updateFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("更新附件")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleGuestDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 2303127837)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.pdfFileName,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.pdfVisible),
      callback: function($$v) {
        _vm.pdfVisible = $$v
      },
      expression: "pdfVisible"
    }
  }, [_c('el-form', [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": _vm.pdfSrc,
      "frameborder": "0"
    }
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增协议客户",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.guestFormVisible),
      callback: function($$v) {
        _vm.guestFormVisible = $$v
      },
      expression: "guestFormVisible"
    }
  }, [_c('el-form', {
    ref: "guestForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.guestForm,
      "label-width": "210px",
      "rules": _vm.guestFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称",
      "prop": "guestComName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入客户名称",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.guestForm.guestComName),
      callback: function($$v) {
        _vm.$set(_vm.guestForm, "guestComName", $$v)
      },
      expression: "guestForm.guestComName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "信用代码",
      "prop": "guestCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入信用代码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.guestForm.guestCode),
      callback: function($$v) {
        _vm.$set(_vm.guestForm, "guestCode", $$v)
      },
      expression: "guestForm.guestCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法人或寄件人姓名",
      "prop": "guestName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入法人或寄件人姓名",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.guestForm.guestName),
      callback: function($$v) {
        _vm.$set(_vm.guestForm, "guestName", $$v)
      },
      expression: "guestForm.guestName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法人或寄件人身份证号",
      "prop": "guestWid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入法人或寄件人身份证号",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.guestForm.guestWid),
      callback: function($$v) {
        _vm.$set(_vm.guestForm, "guestWid", $$v)
      },
      expression: "guestForm.guestWid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法人或寄件人电话",
      "prop": "guestPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入法人或寄件人电话",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.guestForm.guestPhone),
      callback: function($$v) {
        _vm.$set(_vm.guestForm, "guestPhone", $$v)
      },
      expression: "guestForm.guestPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物品名称",
      "prop": "guestGoods"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入物品名称",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.guestForm.guestGoods),
      callback: function($$v) {
        _vm.$set(_vm.guestForm, "guestGoods", $$v)
      },
      expression: "guestForm.guestGoods"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "协议签订时间",
      "prop": "guestDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.guestForm.selGuestDate),
      callback: function($$v) {
        _vm.$set(_vm.guestForm, "selGuestDate", $$v)
      },
      expression: "guestForm.selGuestDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传协议文件"
    }
  }, [_c('div', [_c('input', {
    ref: "upLoadRef",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.handleFileUpload.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadstart),
      expression: "uploadstart"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.uploadXyFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传寄件人或法人有效身份证件"
    }
  }, [_c('div', [_c('input', {
    ref: "upLoadRefWid",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.handleFileUploadWid.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadstartWid),
      expression: "uploadstartWid"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.uploadWidFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.guestFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.fileLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addcomGuest.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新协议客户附件",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.guestFormUpdateVisible),
      callback: function($$v) {
        _vm.guestFormUpdateVisible = $$v
      },
      expression: "guestFormUpdateVisible"
    }
  }, [_c('el-form', {
    ref: "guestFormUpdate",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.guestFormUpdate,
      "label-width": "210px",
      "rules": _vm.guestFormUpdateRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称",
      "prop": "guestComName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入客户名称",
      "auto-complete": "off",
      "disabled": true
    },
    model: {
      value: (_vm.guestFormUpdate.guestComName),
      callback: function($$v) {
        _vm.$set(_vm.guestFormUpdate, "guestComName", $$v)
      },
      expression: "guestFormUpdate.guestComName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "更新协议文件"
    }
  }, [_c('div', [_c('input', {
    ref: "newupLoadRef",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.newhandleFileUpload.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newuploadstart),
      expression: "newuploadstart"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.newuploadXyFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "更新寄件人或法人有效身份证件"
    }
  }, [_c('div', [_c('input', {
    ref: "newupLoadRefWid",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.newhandleFileUploadWid.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newuploadstartWid),
      expression: "newuploadstartWid"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.newuploadWidFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.guestFormUpdateVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.fileLoadingUpdate
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updatecomGuest.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69b15b1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav/enterpriseGuest.vue
// module id = 835
// module chunks = 2